import config from '../aws-exports';
import Amplify, { API } from 'aws-amplify';
import axios from 'axios';
import { ImageDescriptorData, ImageSubject } from './data-service';
import { Auth } from 'aws-amplify';

Amplify.configure(config);
//API.configure(config.amplify.API);

const API_NAME = 'photos';
const PHOTO_SUBMISSION_PATH = '/photo-submission';
const IMAGE_DESCRIPTOR_PATH = '/image-descriptor';

async function getHeaders(): Promise<any> {
    return {};
    const headers = {
        Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`
    }

    return headers;
}

async function getHeadersJson(): Promise<any> {
    const headers = {
        "Content-Type": `application/json`
    };
    return headers;
}

class DescriptorResult {
    upload_url: string;
    descriptor_id: string;
}

export async function createDescriptor(
    descriptor: DescriptorUpdate
): Promise<DescriptorResult> {
    // Submit the metadata and get the presigned URL to upload to S3
    const body = {
        metadata: descriptor,
    };
    const result = await API.post(API_NAME, IMAGE_DESCRIPTOR_PATH, { body: body, headers: await getHeaders() },
    );
    console.log(result);
    return {
        upload_url: result.upload_url,
        descriptor_id: result.descriptor_id
    };
}

export class DescriptorUpdate {
    approved?: boolean;
    subjects?: Array<ImageSubject>;
    name?: string;
    caption?: string;
    metadata?: any
    teamId?: string
    imageType?: string
}

export async function updateDescriptor(id: string, metadata: DescriptorUpdate): Promise<boolean> {
    // Submit the metadata and get the presigned URL to upload to S3
    const body = {
        metadata: metadata,
    };
    const result = await API.put(API_NAME, `${IMAGE_DESCRIPTOR_PATH}?id=${id}`, { body: body, headers: await getHeaders() },
    );
    console.log(result);
    return true;
}

export async function updateDescriptorPublic(id: string): Promise<{public_upload_url}> {
    const result = await API.post(API_NAME, `${IMAGE_DESCRIPTOR_PATH}?id=${id}&action=updatePublic`, { body: {}, headers: await getHeadersJson() } );
    console.log(result);
    return {
        public_upload_url: result.public_upload_url,
    };
}

export async function getDescriptor(id: string): Promise<ImageDescriptorData> {
    const user = await Auth.currentAuthenticatedUser();
    console.log('user.signInUserSession.accessToken.payload["cognito:groups"]' + JSON.stringify(user.signInUserSession.accessToken.payload["cognito:groups"]));
    const result = await API.get(API_NAME, `${IMAGE_DESCRIPTOR_PATH}?id=${id}`, { headers: await getHeaders() });
    console.log(result);
    return result;
}

export async function deleteDescriptor(id: string): Promise<ImageDescriptorData> {
    const result = await API.del(API_NAME, `${IMAGE_DESCRIPTOR_PATH}?id=${id}`, { headers: await getHeaders() });
    console.log(result);
    return result;
}


export async function getUnreviewedDescriptors(): Promise<ImageDescriptorData[]> {
    const result = await API.get(API_NAME, `${IMAGE_DESCRIPTOR_PATH}?where=Unreviewed`, { headers: await getHeaders() });
    console.log(result);
    return result.matches;
}


export async function uploadPhotoToPresignedUrl(presignedUrl: string, photoFile: File): Promise<any> {
    const uploadResult = await axios.put(presignedUrl, photoFile)
    return uploadResult
}